module.exports = __webpack_public_path__ + "img/4.9dacc03b.jpg";